export default {
	state: {
		customerId: "",  
	},
	mutations: {
		setCustomerId(state, customerId) { 
			state.customerId = customerId
		},
		 
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/maint.js